import React, { useEffect, useState } from 'react'
import { Col, Row } from "react-bootstrap"
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri"
import { withTranslation } from 'react-i18next';
import ReactPaginate from "react-paginate"
import moment from 'moment'
import { getClassTypeNotification } from '../../../utils/getClassTypeNotification';
import { getIconClassNotification } from '../../../utils/getIconClassNotification';
import NotiAccionMessage from '../../../utils/NotiAccionMessage';
import { MdEmail } from 'react-icons/md';
import { CapFirst } from '../../../utils/CapFirst';

//TODO: falta corregir las tarjetetas 289 y 290 de jira
function Notificaciones({t, notificaciones=[], trazabilidad, hideStatus}){
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(0)

    const postsPerPage = 10;
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;

    

    useEffect(() => {
        let pC = Math.ceil(notificaciones.length / postsPerPage)
        setPageCount(pC)
    }, [])

    const handlePageClick = (data) => setCurrentPage(data.selected + 1)
    
    return(<>

        {
            notificaciones.slice(indexOfFirstPost, indexOfLastPost).map((notificacion,i) => (
                <Row key={i} className="align-items-center line-after">
                    <Col xs="6" md="1">
                        <div className={`circulo ${getClassTypeNotification(notificacion.notificationType)}`}>
                                {
                                    getIconClassNotification(notificacion.notificationType)
                                } 
                        </div>
                    </Col>
                    <Col xs="6" md={trazabilidad ?  "7" : "11"}>
                        <div>
                            <span className="d-block">
                                <NotiAccionMessage 
                                    notificationType={notificacion.notificationType} 
                                    type={notificacion.type} 
                                    status={notificacion.estatusDeliver}
                                    name_doctor={notificacion.scheduleDTO?.name_doctor}
                                />
                            </span>
                            {notificacion.estatusDeliver &&
                            <span>
                                Estado: {notificacion.estatusDeliver}
                            </span>}
                            <div className="d-flex justify-content-between">
                                <div>Paciente: <span className='etiqueta'>
                                                    {
                                                        notificacion?.patientDTO?.name ?
                                                        `${notificacion?.patientDTO?.name} ${notificacion.patientDTO?.seccondSurname ?? ''} ${notificacion?.patientDTO?.lastName} ${notificacion.patientDTO?.seccondSurname ?? ''}` :
                                                        `${notificacion?.patientDTO?.email}`
                                                    }
                                                </span>
                                </div>
                                {
                                    notificacion?.patientDTO?.name &&
                                    <div>
                                        <MdEmail className="mb-1"/>: <span className='etiqueta'>{notificacion?.patientDTO?.email}</span>
                                    </div>
                                }
                            </div>
                            {
                                notificacion.documentSend &&
                                <ul>
                                    {
                                        notificacion.documentSend.split(",").slice(0, notificacion.documentSend.split(",").length-1).map((doc,i)=>(
                                            <li key={i}>{CapFirst(doc.trim())}</li>
                                        ))
                                    }
                                </ul>
                            }
                            <span className='etiqueta notificacion-tiempo-atras font-size-08rem'>
                                {moment(notificacion?.createdDate, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm")}
                            </span>
                        </div>
                    </Col>
                    {trazabilidad && <Col xs="12" md="4">
                        <span className="font-size-09rem d-block">{notificacion.createUser && `creado por: ${notificacion.createUser?.name}`}</span>
                        {!hideStatus && <span className="font-size-08rem text-muted d-block">{notificacion.estatusDeliver && notificacion.estatusDeliver}</span>}
                        <span className="font-size-08rem text-muted d-block">{notificacion.messageDeliver && notificacion.messageDeliver}</span>
                    </Col>}
                </Row>
               
            ))
        }

        {
            notificaciones.length > 0 && <Row className="mt-5">
                <Col>
                    <ReactPaginate
                        previousLabel={<RiArrowLeftSLine />}
                        nextLabel={<RiArrowRightSLine />}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={3}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                    />
                </Col>
            </Row>
        }
    </>)
}

export default withTranslation()(Notificaciones)


/* <div className='info-notificacion'>
                            <span className='etiqueta'>
                                {
                                    notificacion?.patientDTO?.name === null ?
                                    notificacion.patientDTO.account.name :
                                    `${notificacion?.patientDTO?.name} ${notificacion?.patientDTO?.lastName}`
                                }
                            </span>{' '}

                                <NotiAccionMessage notificationType={notificacion.notificationType}/>
                                {notificacion.documentSend && ` (${notificacion.documentSend.split(",").join("/")})`}
                            {' '}<span className='etiqueta'>{moment(notificacion?.scheduleDTO?.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm")}</span> <br/>
                            {
                                fecha1.diff(moment(notificacion?.createdDate), 'days') === 0
                                ? <span className='etiqueta notificacion-tiempo-atras'>
                                    {t('hace')}{' '}
                                    {fecha1.diff(moment(notificacion?.createdDate), 'hours') === 0 ? fecha1.diff(moment(notificacion?.createdDate), 'minutes') : fecha1.diff(moment(notificacion?.createdDate), 'hours')}{' '}
                                    {fecha1.diff(moment(notificacion?.createdDate), 'hours') === 0 ? 'min' : t('horas')}</span>
                                : <span className='etiqueta notificacion-tiempo-atras'>
                                    {t('hace')}{' '}
                                    {fecha1.diff(moment(notificacion?.createdDate), 'days')} {' '}
                                    {fecha1.diff(moment(notificacion?.createdDate), 'days') > 1 ? t('dias') : 'día'}</span>
                            }
                        </div> */